@if (showSuccessMessage) {
  <div class="alert alert-success custom-alert">
    <span class="alert-icon"><cx-icon class="cx-icon fas fa-check-circle"></cx-icon></span>
    <span
      >{{ 'dispenserAgreement.newClaim.uploadSuccessCreditRequest' | cxTranslate }}
      <a [routerLink]="{ cxRoute: 'shipmentCreditClaim' } | cxUrl">
        {{ 'dispenserAgreement.newClaim.clickingHere' | cxTranslate }}
      </a>
    </span>
    <button type="button" (click)="showSuccessMessage = false" class="close">
      <cx-icon class="cx-icon fas fa-times"></cx-icon>
    </button>
  </div>
}

<a
  class="btn btn-action btn-small btn-back back-navigation"
  [ngStyle]="{ 'margin-top': showSuccessMessage ? '76px' : '0' }"
  [routerLink]="{ cxRoute: 'dispenserAgreements' } | cxUrl"
  >
  <i class="fas fa-arrow-left mr-1"></i>
  {{ 'shared.backTo.dispensers' | cxTranslate }}
</a>

<section class="cx-section">
  <mat-card class="new-credit-claim">
    <h1 class="new-credit-claim__title">{{ 'dispenserAgreement.newClaim.title' | cxTranslate }}</h1>
    <div class="new-credit-claim__section">
      <h4>{{ 'dispenserAgreement.newClaim.downloadNewForm' | cxTranslate }}</h4>
      <div class="new-credit-claim__section__content">
        <p class="new-credit-claim__section__content__text">
          {{ 'dispenserAgreement.newClaim.downloadNewFormDescription' | cxTranslate }}
        </p>
        <a
          class="new-credit-claim__section__content__download-link"
          (click)="onDownloadFormClick()"
          target="_blank"
          title="Download address form"
          >
          <i [ngClass]="downloadSpinner ? 'fa-spinner fa-spin' : 'fa-download'" class="fa"></i>
          {{ 'dispenserAgreement.newClaim.downloadForm' | cxTranslate }}</a
          >
        </div>
      </div>
      <mat-divider></mat-divider>
      <div class="new-credit-claim__section new-credit-claim__section__upload">
        <h4>{{ 'dispenserAgreement.newClaim.uploadTitle' | cxTranslate }}</h4>
        <div class="new-credit-claim__section__content">
          <p class="new-credit-claim__section__content__text">
            {{ 'dispenserAgreement.newClaim.uploadNewFormDescription' | cxTranslate }}
            <br />
            <span class="new-credit-claim__warning">
              {{ 'dispenserAgreement.newClaim.fileFormatAdvise' | cxTranslate }}
            </span>
          </p>
          <div class="row">
            <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
              <ng-container>
                <input
                  id="same-address-input"
                  class="new-credit-claim__section__content__upload"
                  type="file"
                  [(ngModel)]="fileInputControl"
                  (change)="onUploadClaimForm($event.target.files)"
                  />
                  <label for="same-address-input" class="btn btn-primary default">
                    <i [ngClass]="uploadSpinner ? 'fa-spinner fa-spin' : ''" class="fa"></i>
                    {{ 'dispenserAgreement.newClaim.uploadForm' | cxTranslate }}</label
                    >
                  </ng-container>
                </div>
              </div>
            </div>
          </div>
        </mat-card>
      </section>
